const prefix = "nativeComms";

export default {
  // Turning JS Menu on or off
  SHOW_JS_APP_MENU: `${prefix}:SHOW_JS_APP_MENU`,

  // Welcome Data
  SHOW_WELCOME: `${prefix}:SHOW_WELCOME`,
  WELCOME_UPDATE_ALL: `${prefix}:WELCOME_UPDATE_ALL`,
  WELCOME_UPDATE_RECENT_FILES: `${prefix}:WELCOME_UPDATE_RECENT_FILES`,
  WELCOME_UPDATE_EXAMPLE_FILES: `${prefix}:WELCOME_UPDATE_EXAMPLE_FILES`,
  WELCOME_UPDATE_STANDARD_TEMPLATES: `${prefix}:WELCOME_UPDATE_STANDARD_TEMPLATES`,
  WELCOME_UPDATE_CUSTOM_TEMPLATES: `${prefix}:WELCOME_UPDATE_CUSTOM_TEMPLATES`,

  CUSTOM_TEMPLATE_INDEX: `${prefix}:CUSTOM_TEMPLATE_INDEX`,
  CUSTOM_TEMPLATE_DATA: `${prefix}:CUSTOM_TEMPLATE_DATA`,
  CUSTOM_TEMPLATE_DELETED: `${prefix}:CUSTOM_TEMPLATE_DELETED`,

  // Loading Data
  SET_FILE_NAME: `${prefix}:SET_FILE_NAME`,
  DATA_FROM_NATIVE: `${prefix}:DATA_FROM_NATIVE`,
  DATA_UPDATE_FROM_NATIVE: `${prefix}:DATA_UPDATE_FROM_NATIVE`,
  TEMPLATE_DATA_FROM_NATIVE: `${prefix}:TEMPLATE_DATA_FROM_NATIVE`,
  V2_DATA_FROM_NATIVE: `${prefix}:V2_DATA_FROM_NATIVE`,
  STANDARD_DATA_FROM_NATIVE: `${prefix}:STANDARD_DATA_FROM_NATIVE`,
  PREFERENCE_DATA_FROM_NATIVE: `${prefix}:PREFERENCE_DATA_FROM_NATIVE`,
  AUTO_UPDATE_DATA_FROM_NATIVE: `${prefix}:AUTO_UPDATE_DATA_FROM_NATIVE`,
  FILE_VERSION_TOO_LOW_FROM_NATIVE: `${prefix}:FILE_VERSION_TOO_LOW_FROM_NATIVE`,
  EDITING_FILE_VERSION_TOO_LOW_FROM_NATIVE: `${prefix}:EDITING_FILE_VERSION_TOO_LOW_FROM_NATIVE`,

  // Syncing Actions
  SYNC_DATA_FROM_NATIVE: `${prefix}:SYNC_DATA_FROM_NATIVE`,
  SYNC_BROWSE_RESULT: `${prefix}:SYNC_BROWSE_RESULT`,
  ULYSSES_AUTH_REQUESTED: `${prefix}:ULYSSES_AUTH_REQUESTED`,
  ULYSSES_AUTH_RECEIVED: `${prefix}:ULYSSES_AUTH_RECEIVED`,
  ULYSSES_TREE_RESULT: `${prefix}:ULYSSES_TREE_RESULT`,
  EXTERNAL_SYNC_UPDATE_RESULT: `${prefix}:EXTERNAL_SYNC_UPDATE_RESULT`,
  EXTERNAL_SYNC_UPDATE_PROGRESS: `${prefix}:EXTERNAL_SYNC_UPDATE_PROGRESS`,
  SYNC_FILE_MISSING: `${prefix}:SYNC_FILE_MISSING`,

  ADD_IMAGE_BROWSE_RESULT: `${prefix}:ADD_IMAGE_BROWSE_RESULT`,
  ADD_ATTACHMENT_BROWSE_RESULT: `${prefix}:ADD_ATTACHMENT_BROWSE_RESULT`,
  ADD_LINK_BROWSE_RESULT: `${prefix}:ADD_LINK_BROWSE_RESULT`,
  ADD_IMAGE_LINK_BROWSE_RESULT: `${prefix}:ADD_IMAGE_LINK_BROWSE_RESULT`,

  IMPORT_CSV_DATA: `${prefix}:IMPORT_CSV_DATA`,

  // Printing Commands
  SET_FONT_SERVER_URL: `${prefix}:SET_FONT_SERVER_URL`,
  PRINT_DATA_FROM_NATIVE: `${prefix}:PRINT_DATA_FROM_NATIVE`,
  FILE_PRINT: `${prefix}:FILE_PRINT`,

  // Export
  FILE_EXPORT: `${prefix}:FILE_EXPORT`,
  FILE_EXPORT_CSV: `${prefix}:FILE_EXPORT_CSV`,
  FILE_EXPORT_IMAGE: `${prefix}:FILE_EXPORT_IMAGE`,
  FILE_EXPORT_TSF: `${prefix}:FILE_EXPORT_TSF`,

  // File Commands
  STORE_LINKS_AS_RELATIVE: `${prefix}:STORE_LINKS_AS_RELATIVE`,
  STORE_LINKS_AS_ABSOLUTE: `${prefix}:STORE_LINKS_AS_ABSOLUTE`,
  CONVERT_LINKS_TO_RELATIVE_RESULT: `${prefix}:CONVERT_LINKS_TO_RELATIVE_RESULT`,
  CONVERT_LINKS_TO_ABSOLUTE_RESULT: `${prefix}:CONVERT_LINKS_TO_ABSOLUTE_RESULT`,

  // Edit Commands
  UNDO: `${prefix}:UNDO`,
  REDO: `${prefix}:REDO`,
  CUT: `${prefix}:CUT`,
  COPY: `${prefix}:COPY`,
  PASTE: `${prefix}:PASTE`,
  OPEN_SEARCH: `${prefix}:OPEN_SEARCH`,
  OPEN_SEARCH_AND_REPLACE: `${prefix}:OPEN_SEARCH_AND_REPLACE`,

  // View Commands
  SHOW_TIMELINE: `${prefix}:SHOW_TIMELINE`,
  SHOW_SPREADSHEET: `${prefix}:SHOW_SPREADSHEET`,
  SHOW_NARRATIVE: `${prefix}:SHOW_NARRATIVE`,
  SHOW_OUTLINE: `${prefix}:SHOW_OUTLINE`,
  SHOW_SUBWAY: `${prefix}:SHOW_SUBWAY`,
  SHOW_RELATIONSHIPS: `${prefix}:SHOW_RELATIONSHIPS`,
  SHOW_MINDMAP: `${prefix}:SHOW_MINDMAP`,
  SHOW_NEW_MINDMAP: `${prefix}:SHOW_NEW_MINDMAP`,

  SHOW_ITEM_LIST: `${prefix}:SHOW_ITEM_LIST`,
  SHOW_CALENDAR_MARKERS: `${prefix}:SHOW_CALENDAR_MARKERS`,

  EXPAND_PARENT_ITEM: `${prefix}:EXPAND_PARENT_ITEM`,
  COLLAPSE_PARENT_ITEM: `${prefix}:COLLAPSE_PARENT_ITEM`,

  TOGGLE_INSPECTOR: `${prefix}:TOGGLE_INSPECTOR`,
  SHOW_INSPECTOR_RANGE_TAB: `${prefix}:SHOW_INSPECTOR_RANGE_TAB`,
  SHOW_INSPECTOR_CONSTRAINTS_TAB: `${prefix}:SHOW_INSPECTOR_CONSTRAINTS_TAB`,
  SHOW_INSPECTOR_RELATIONSHIPS_TAB: `${prefix}:SHOW_INSPECTOR_RELATIONSHIPS_TAB`,
  SHOW_INSPECTOR_PROPERTIES_TAB: `${prefix}:SHOW_INSPECTOR_PROPERTIES_TAB`,
  SHOW_INSPECTOR_ATTACHMENTS_TAB: `${prefix}:SHOW_INSPECTOR_ATTACHMENTS_TAB`,

  TOGGLE_CALENDAR_MARKERS: `${prefix}:TOGGLE_CALENDAR_MARKERS`,
  TOGGLE_GLOBAL_FILTER: `${prefix}:TOGGLE_GLOBAL_FILTER`,
  TOGGLE_LOCAL_FILTER: `${prefix}:TOGGLE_LOCAL_FILTER`,
  CLEAR_GLOBAL_FILTER: `${prefix}:CLEAR_GLOBAL_FILTER`,
  CLEAR_LOCAL_FILTER: `${prefix}:CLEAR_LOCAL_FILTER`,

  SHOW_SETTINGS: `${prefix}:SHOW_SETTINGS`,
  SHOW_PREFERENCES: `${prefix}:SHOW_PREFERENCES`,
  SHOW_BACKUP: `${prefix}:SHOW_BACKUP`,
  SHOW_SAVE_TEMPLATE_MODAL: `${prefix}:SHOW_SAVE_TEMPLATE_MODAL`,
  SAVE_AS_TEMPLATE_WITH_NAME: `${prefix}:SAVE_AS_TEMPLATE_WITH_NAME`,
  SHOW_ABOUT: `${prefix}:SHOW_ABOUT`,

  // View -> Split Commands
  SPLIT_HORIZONTALLY: `${prefix}:SPLIT_HORIZONTALLY`,
  SPLIT_VERTICALLY: `${prefix}:SPLIT_VERTICALLY`,
  ADD_SPLIT_TOP: `${prefix}:ADD_SPLIT_TOP`,
  ADD_SPLIT_BOTTOM: `${prefix}:ADD_SPLIT_BOTTOM`,
  ADD_SPLIT_LEFT: `${prefix}:ADD_SPLIT_LEFT`,
  ADD_SPLIT_RIGHT: `${prefix}:ADD_SPLIT_RIGHT`,
  CLOSE_SPLIT: `${prefix}:CLOSE_SPLIT`,
  CLOSE_OTHER_SPLITS: `${prefix}:CLOSE_OTHER_SPLITS`,

  // Navigate Commands
  SWITCH_FOCUS: `${prefix}:SWITCH_FOCUS`,
  SCROLL_TO_DATE: `${prefix}:SCROLL_TO_DATE`,
  SCROLL_TO_SELECTION: `${prefix}:SCROLL_TO_SELECTION`,
  SHOW_BOOKMARKS: `${prefix}:SHOW_BOOKMARKS`,

  // Navigate -> Selection Commands
  SELECT_ALL: `${prefix}:SELECT_ALL`,
  SELECT_FIRST_ITEM: `${prefix}:SELECT_FIRST_ITEM`,
  SELECT_PREVIOUS_ITEM: `${prefix}:SELECT_PREVIOUS_ITEM`,
  SELECT_NEXT_ITEM: `${prefix}:SELECT_NEXT_ITEM`,
  SELECT_LAST_ITEM: `${prefix}:SELECT_LAST_ITEM`,
  SELECT_ALL_BEFORE_CURRENT_SELECTION: `${prefix}:SELECT_ALL_BEFORE_CURRENT_SELECTION`,
  SELECT_ALL_AFTER_CURRENT_SELECTION: `${prefix}:SELECT_ALL_AFTER_CURRENT_SELECTION`,
  SELECT_NONE: `${prefix}:SELECT_NONE`,

  // Timeline Commands
  ADD_ITEM: `${prefix}:ADD_ITEM`,
  ADD_CALENDAR_MARKER: `${prefix}:ADD_CALENDAR_MARKER`,
  PERMANENT_DELETE: `${prefix}:PERMANENT_DELETE`,
  REMOVE_FROM_VIEW: `${prefix}:REMOVE_FROM_VIEW`,
  SHIFT_ITEMS_BY: `${prefix}:SHIFT_ITEMS_BY`,
  MAKE_CONSECUTIVE: `${prefix}:MAKE_CONSECUTIVE`,
  MAKE_DEPENDENT: `${prefix}:MAKE_DEPENDENT`,
  REMOVE_DEPENDENCIES: `${prefix}:REMOVE_DEPENDENCIES`,
  EMBED_IN_NEW_PARENT: `${prefix}:EMBED_IN_NEW_PARENT`,
  EMBED_IN_NARRATIVE_FOLDER: `${prefix}:EMBED_IN_NARRATIVE_FOLDER`,

  // Sync Commands
  TOGGLE_SYNC_BINDER: `${prefix}:TOGGLE_SYNC_BINDER`,
  OPEN_SYNC_SETTINGS: `${prefix}:OPEN_SYNC_SETTINGS`,
  EXECUTE_SYNC: `${prefix}:EXECUTE_SYNC`,

  // Tutorial Commands
  SHOW_TUTORIAL: `${prefix}:SHOW_TUTORIAL`,
  SET_COMPLETED_TUTORIAL_STEPS: `${prefix}:SET_COMPLETED_TUTORIAL_STEPS`,
  SET_TUTORIAL_SILENCED: `${prefix}:SET_TUTORIAL_SILENCED`,

  // Are we currently in a text field?
  IS_FOCUS_ON_TEXT: `${prefix}:IS_FOCUS_ON_TEXT`,

  // Response after showing a Yes-No-Cancel dialog
  ALERT_PROMPT_RESPONSE: `${prefix}:ALERT_PROMPT_RESPONSE`,
  OK_CANCEL_PROMPT_RESPONSE: `${prefix}:OK_CANCEL_PROMPT_RESPONSE`,
  YES_NO_PROMPT_RESPONSE: `${prefix}:YES_NO_PROMPT_RESPONSE`,
  YES_NO_CANCEL_PROMPT_RESPONSE: `${prefix}:YES_NO_CANCEL_PROMPT_RESPONSE`,

  // Auto Backuo
  BACKUP_DATA_RESULT: `${prefix}:BACKUP_DATA_RESULT`,

  // Text sizes
  USE_TEXT_SIZE_SMALL: `${prefix}:USE_TEXT_SIZE_SMALL`,
  USE_TEXT_SIZE_MEDIUM: `${prefix}:USE_TEXT_SIZE_MEDIUM`,
  USE_TEXT_SIZE_LARGE: `${prefix}:USE_TEXT_SIZE_LARGE`,
  USE_TEXT_SIZE_XLARGE: `${prefix}:USE_TEXT_SIZE_XLARGE`,
  USE_TEXT_SIZE_XXLARGE: `${prefix}:USE_TEXT_SIZE_XXLARGE`,
  SET_FONT_PERCENTAGE: `${prefix}:SET_FONT_PERCENTAGE`,

  // Registration Messages
  UPDATE_LICENSE_STATUS: `${prefix}:UPDATE_LICENSE_STATUS`,
  CHECK_FOR_LICENSED_UPDATE_RESPONSE: `${prefix}:CHECK_FOR_LICENSED_UPDATE_RESPONSE`,
  SHOW_RELEASE_NOTES: `${prefix}:SHOW_RELEASE_NOTES`,
  WEBSITE_UPDATES_RESPONSE: `${prefix}:WEBSITE_UPDATES_RESPONSE`,

  // iOS Device Info
  SET_DEVICE_INSETS: `${prefix}:SET_DEVICE_INSETS`,
  ENTER_EDIT_MODE: `${prefix}:ENTER_EDIT_MODE`,
  EXIT_EDIT_MODE: `${prefix}:EXIT_EDIT_MODE`,

  // iOS Conflict Resolution
  SHOW_CONFLICTS_MODAL: `${prefix}:SHOW_CONFLICTS_MODAL`,
  HIDE_CONFLICTS_MODAL: `${prefix}:HIDE_CONFLICTS_MODAL`,

  // ENABLE_SENTRY_LOGGING
  ENABLE_SENTRY_LOG: `${prefix}:ENABLE_SENTRY_LOG`
};
